import React, { useEffect, useState } from "react";
import classes from "./TopAdmits.module.scss";
import CustomImage from "../../CustomImage";
import useIsMobile from "../../../hooks/useIsMobile";
import useEmblaOverflow from "../../../hooks/useEmblaOverflow";

const TopAdmits = ({ countryData }: { countryData: any }) => {
  const admitsData = countryData?.topAdmits ?? [];
  const isMobile = useIsMobile(768);
  const { emblaRef, emblaApi, hasOverflow, canScrollPrev, canScrollNext, scrollPrev, scrollNext } = useEmblaOverflow();

  const [selectedIndex, setSelectedIndex] = useState(0);

  useEffect(() => {
    if (!emblaApi) return;

    const onSelect = () => setSelectedIndex(emblaApi.selectedScrollSnap());

    onSelect();
    emblaApi.on("select", onSelect);
    emblaApi.on("reInit", onSelect);

    return () => {
      emblaApi.off("select", onSelect);
      emblaApi.off("reInit", onSelect);
    };
  }, [emblaApi]);

  const renderCards = () =>
    admitsData?.admitCard?.map((student: any, index: number) => (
      <div className={`${classes["ta-slide"]} ${isMobile && index !== selectedIndex ? classes["ta-slide-inactive"] : ""}`} key={student?.id}>
        <div className={classes["ta-card"]}>
          <div className={classes["ta-avatar-wrap"]}>
            <CustomImage
              src={student?.image?.url ?? "/icons/student-placeholder.svg"}
              alt={student?.name}
              width={93}
              height={93}
              className={classes["ta-avatar"]}
            />
            <div className={classes["ta-badge"]}>
              <CustomImage src="/icons/medal_icon.svg" alt="gold-medal" width={73} height={73} />
            </div>
          </div>
          <h3 className={classes["ta-name"]}>{student.name}</h3>
          <p className={classes["ta-university"]}>{student.university}</p>
          <p className={classes["ta-intake"]}>{student.intake}</p>
        </div>
      </div>
    ));

  const arrowLeft = (
    <button
      className={`${classes["ta-arrow"]}${canScrollPrev ? "" : ` ${classes["ta-arrow-disabled"]}`}`}
      onClick={scrollPrev}
      disabled={!canScrollPrev}
      aria-label="Previous"
    >
      <CustomImage src="/new-images/left-arrow.svg" height={17} width={10} alt="left-arrow" />
    </button>
  );

  const arrowRight = (
    <button
      className={`${classes["ta-arrow"]}${canScrollNext ? "" : ` ${classes["ta-arrow-disabled"]}`}`}
      onClick={scrollNext}
      disabled={!canScrollNext}
      aria-label="Next"
    >
      <CustomImage src="/new-images/right-arrow.svg" height={17} width={10} alt="right-arrow" />
    </button>
  );

  return (
    <section id="top-admits" className={classes["ta-section"]}>
      <div className={classes["ta-container"]}>
        <h2 className={classes["ta-heading"]}>{admitsData?.title ?? ""}</h2>
        <div className={classes["ta-subtext"]} dangerouslySetInnerHTML={{ __html: admitsData?.description ?? "" }}></div>

        {isMobile ? (
          <div className={classes["ta-carousel-wrap"]}>
            <div className={classes["ta-viewport"]} ref={emblaRef}>
              <div className={classes["ta-slider"]}>{renderCards()}</div>
            </div>
            {hasOverflow && (
              <div className={classes["ta-arrows-below"]}>
                {arrowLeft}
                {arrowRight}
              </div>
            )}
          </div>
        ) : (
          <>
            <div style={countryData?.topAdmits?.admitCard?.length < 5 ? { justifyContent: "center" } : {}} className={classes["ta-carousel-wrap"]}>
              <div className={classes["ta-viewport"]} ref={emblaRef}>
                <div style={countryData?.topAdmits?.admitCard?.length < 5 ? { justifyContent: "center" } : {}} className={classes["ta-slider"]}>
                  {renderCards()}
                </div>
              </div>
            </div>

            {hasOverflow && (
              <div className={classes["ta-arrows-container"]}>
                {arrowLeft}
                {arrowRight}
              </div>
            )}
          </>
        )}
      </div>
    </section>
  );
};

export default TopAdmits;
